import { render, staticRenderFns } from "./grouping_switch.vue?vue&type=template&id=394e21b8&scoped=true&"
import script from "./grouping_switch.vue?vue&type=script&lang=js&"
export * from "./grouping_switch.vue?vue&type=script&lang=js&"
import style0 from "./grouping_switch.vue?vue&type=style&index=0&id=394e21b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394e21b8",
  null
  
)

export default component.exports